/**
 * Every outbound URL on the landing page lives here.
 *
 * The store and social entries are empty until the apps and accounts are
 * published. `ExternalLink` renders an empty entry as a non-navigating
 * placeholder, so filling one in below is the only change needed to make the
 * button live.
 */
export const externalLinks = {
  console: 'https://console.shareshutter.com',
  appStore: 'https://apps.apple.com/us/app/shareshutter/id6800558483',
  googlePlay: 'https://play.google.com/store/apps/details?id=com.devroldy.shareshutter',
  instagram: 'https://www.instagram.com/shareshutterapp',
  tiktok: 'https://www.tiktok.com/@shareshutterapp',
};

/**
 * The one address people can reach ShareShutter on. Also the support address
 * the Terms and the Privacy Policy point at, so there is a single inbox to
 * change if it ever moves.
 */
export const contactEmail = 'shareshutterapp@gmail.com';

/**
 * The href behind every Contact link. The subject is prefilled so a message
 * arriving from the site is recognisable, and encoded because a raw space in a
 * mailto is not valid everywhere.
 */
export const contactMailto = `mailto:${contactEmail}?subject=${encodeURIComponent(
  'ShareShutter support',
)}`;

export default externalLinks;
